import * as Sentry from "@sentry/angular";
import { enableProdMode } from '@angular/core';

import { environment } from './environments/environment';
import {bootstrapApplication} from '@angular/platform-browser';
import {AppComponent} from './app/app.component';
import {appConfig} from './app/app.config';

const sentryEnabled = environment.production;

Sentry.init({
    dsn: "https://2babace2670fb36aa49195a26b250793@o4510515377078272.ingest.us.sentry.io/4510515378061312",
    enabled: sentryEnabled,
    integrations: sentryEnabled
        ? [Sentry.browserTracingIntegration(), Sentry.replayIntegration()]
        : [],
    tracesSampleRate: sentryEnabled ? 0.1 : 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: sentryEnabled ? 1 : 0,
    enableLogs: sentryEnabled,
    sendDefaultPii: sentryEnabled,
})

if (environment.production) {
  enableProdMode();
}

// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.log(err));

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error('err', err),
);